import FranquiasIndexPage from "@/Pages/Franquias/index.vue";
import NewEditFranquiaPage from "@/Pages/Franquias/NewEditFranquiaPage.vue";
import { can } from "@/plugins/can";

const checkPermission = (permissions) => {
  return (to, from, next) => {
    if (!can(permissions)) {
      return next({ name: "NaoAutorizado" });
    }
    return next();
  };
};

export default [
  {
    path: "/franquias",
    name: "franquias",
    component: FranquiasIndexPage,
    beforeEnter: checkPermission(["franquias.*", "franquias.criarFranquia"]),
  },
  {
    path: "/franquias/create",
    name: "franquias.create",
    component: NewEditFranquiaPage,
    props: { editing: false },
  },
  {
    path: "/franquias/edit/:franquia_id",
    name: "franquias.edit",
    component: NewEditFranquiaPage,
    props: { editing: true },
  },
];
